'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dIncoming$002dDrug$002dRequest$002dProcessed from "./app.api.-Pharmacy-App-Update$-Incoming-Drug-Request-Processed.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ as $c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ };
$c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ as $h_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ };
$h_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype = $c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype;
$c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype.toString__T = (function() {
  return "IncomingDrugRequestProcessed";
});
$c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed = (function(x$0) {
  var id$6 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dIncoming$002dDrug$002dRequest$002dProcessed.$c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed(id$6);
});
$c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed(p);
});
var $d_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$, "app.api.PharmacyAppUpdate$IncomingDrugRequestProcessed$", ({
  Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ as $d_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ };
var $n_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$;
function $m_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$)) {
    $n_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ = new $c_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$;
}
export { $m_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ as $m_Lapp_api_PharmacyAppUpdate$IncomingDrugRequestProcessed$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-Incoming-Drug-Request-Processed$.js.map
